import React from "react";
import { Mail, Clock, MessageCircle } from "lucide-react";

const ContactSection = ({ className = "" }) => {
    const whatsappNumber = "+917602317189";
    const emailAddress = "peerchargeev@gmail.com";

    return (
        <div className={`space-y-8 ${className}`}>
            <ContactInfoCard
                icon={<Mail className="w-6 h-6 text-[#4ade80]" />}
                title="Email Us"
                description="We'll respond within 24 hours."
                link={`mailto:${emailAddress}`}
                linkText={emailAddress}
            />
            <ContactInfoCard
                icon={<MessageCircle className="w-6 h-6 text-[#4ade80]" />}
                title="WhatsApp"
                description="Chat with us for instant support."
                link={`https://wa.me/${whatsappNumber}`}
                linkText="Chat on WhatsApp"
            />
            <ContactInfoCard
                icon={<Clock className="w-6 h-6 text-[#4ade80]" />}
                title="Business Hours"
                description="Monday - Friday: 9:00 AM - 6:00 PM"
                secondaryText="Saturday - Sunday: Closed"
            />
        </div>
    );
};

const ContactInfoCard = ({ icon, title, description, link, linkText, secondaryText }) => (
    <div className="flex items-start gap-4">
        <div className="bg-gray-800 h-12 w-12 rounded-lg flex-shrink-0 flex items-center justify-center">
            {icon}
        </div>
        <div>
            <h4 className="text-lg font-semibold text-white">{title}</h4>
            <p className="text-gray-400">{description}</p>
            {secondaryText && <p className="text-gray-400">{secondaryText}</p>}
            {link && linkText && (
                <a href={link} target="_blank" rel="noopener noreferrer" className="text-[#4ade80] hover:underline break-all">
                    {linkText}
                </a>
            )}
        </div>
    </div>
);

export default ContactSection;

